import React, { useState,useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo3.svg";
import close from "../../assets/images/close.svg";
import LanguageSelection from "./LanguageSelection";
import { useDispatch, useSelector } from "react-redux";
import { changeShowMenu } from "../../redux/slices/showMenuSlice";
import { motion, AnimatePresence } from "framer-motion";

const MobileHeader = () => {
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const showMenu = useSelector((state) => state.showMenu.showMenu);
  const dispatch = useDispatch();
  // MobileHeader.js içinde:
useEffect(() => {
    if (showMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showMenu]);

  return (
    <AnimatePresence>
      {showMenu && (
        <motion.div
          className="mobile-header"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="menu"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            <div className="logo">
              <div>
                <Link onClick={() => dispatch(changeShowMenu(false))} to="/">
                  <img src={logo} alt="" />
                </Link>
              </div>
              <div
                onClick={() => {
                  dispatch(changeShowMenu(false));
                  
                }}
                style={{pointerEvents:"auto"}}
              >
                <img src={close} alt="" style={{cursor:"pointer"}}/>
              </div>
            </div>
            <div className="content">
              <div className="w-100 my-2 d-flex justify-content-center align-items-center">
                <LanguageSelection />
              </div>
              <div className="menu-txt">
                <span>{t("menu")}</span>
              </div>
              <ul>
                <li>
                  <Link onClick={() => dispatch(changeShowMenu(false))} to="/">
                    {t("home_page")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => dispatch(changeShowMenu(false))}
                    to={lang === "tr" ? "/hakkimizda" : "/about"}
                  >
                    {t("about")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => dispatch(changeShowMenu(false))}
                    to={lang === "tr" ? "/istasyonlar" : "/stations"}
                  >
                    {t("station")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => dispatch(changeShowMenu(false))}
                    to={lang === "tr" ? "/is-ortaklarimiz" : "/partner"}
                  >
                    {t("our_business_partners")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => dispatch(changeShowMenu(false))}
                    to={lang === "tr" ? "/iletisim" : "/contact"}
                  >
                    {t("communication")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => dispatch(changeShowMenu(false))}
                    to={lang === "tr" ? "/sss" : "/faq"}
                  >
                    {t("sss2")}
                  </Link>
                </li>
              </ul>
              <div className="bottom">
                <div>
                  <Link onClick={() => dispatch(changeShowMenu(false))} to="/">
                    <img src={logo} alt="" />
                  </Link>
                </div>
                {/* <div className="mt-3 p20">
                  <span className="copyright">{t("copyright")}</span>
                </div> */}
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileHeader;
